import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/iconfont/iconfont.css'
import 'babel-polyfill'
import layer from 'vue-layer'
import baseUrl from './api/base.js';

import Blob from '../src/excel/Blob'
/*import Export2Excel from '../src/excel/Export2Excel'*/

import echarts from "echarts";

Vue.use(ElementUI);

import VueAMap from 'vue-amap';
Vue.use(VueAMap);

Vue.prototype.$layer = layer(Vue);
Vue.prototype.$baseUrl = baseUrl;

VueAMap.initAMapApiLoader({
    // 高德key
    key: 'fa87ce7d142e0fbb6b79c53a5cfd1f59',
    // 插件集合 （插件按需引入）
    plugin: ['AMap.Geocoder','AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MarkerClusterer'],
    v: '1.4.15', // 我也不知道为什么要写这个，不写项目会报错，而且我随便写的，跟我下载的版本对应不了
    uiVersion: '1.0.11' // ui版本号，也是需要写
})


import './mock/index.js';  // 该项目所有请求使用mockjs模拟
import './login.js'
import './ui.js'
Vue.config.productionTip = false;


var vm=new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js